import { Expose, Transform } from 'class-transformer';

import { SnModel } from '@lib/common/models';

import { SnCamera } from '../camera';

export class SnCameraGroup extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public name: string;

  @Expose()
  public locked: boolean;

  @Expose({ name: 'cameraGroups' })
  @Transform((value) => {
    return value?.map((cam) => cam.camera);
  })
  public cameras: SnCamera[];

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
